import { violet, blackA } from "@radix-ui/colors";
import { styled } from "/stitches.config";

import * as SliderPrimitive from "@radix-ui/react-slider";
import * as LabelPrimitive from "@radix-ui/react-label";
import * as SwitchPrimitive from "@radix-ui/react-switch";

import { CirclePicker } from "react-color";

const StyledSlider = styled(SliderPrimitive.Root, {
  position: "relative",
  display: "flex",
  alignItems: "center",
  userSelect: "none",
  touchAction: "none",
  width: 120,

  '&[data-orientation="horizontal"]': {
    height: 20,
  },

  '&[data-orientation="vertical"]': {
    flexDirection: "column",
    width: 20,
    height: 100,
  },
});

const StyledTrack = styled(SliderPrimitive.Track, {
  background: "white",
  position: "relative",
  flexGrow: 1,
  borderRadius: "9999px",

  '&[data-orientation="horizontal"]': { height: 2 },
  '&[data-orientation="vertical"]': { width: 2 },
});

const StyledRange = styled(SliderPrimitive.Range, {
  position: "absolute",
  background: "#7B61FF",
  borderRadius: "9999px",
  height: "100%",
});

const StyledThumb = styled(SliderPrimitive.Thumb, {
  all: "unset",
  display: "block",
  width: 8,
  height: 8,
  background: "#7B61FF",
  borderRadius: 10,
  "&:hover": { backgroundColor: violet.violet3 },
  "&:focus": { boxShadow: `0 0 0 5px ${blackA.blackA8}` },
});

const Slider = (props) => (
  <StyledSlider {...props}>
    <StyledTrack>
      <StyledRange />
    </StyledTrack>
    <StyledThumb />
  </StyledSlider>
);

const Label = styled(LabelPrimitive.Root, {
  fontSize: "$1",
  fontWeight: 500,
  userSelect: "none",
});

const Option = styled("span", {
  display: "flex",
  alignItems: "center",
  justifyContent: "space-between",
  width: 254,
  height: 32,
});

export function SliderOption({ label, ...props }) {
  return (
    <Option style={{}}>
      <Label>{label}</Label>
      <Slider {...props} />
      <Label style={{ width: 37 }}>{props.defaultValue}%</Label>
    </Option>
  );
}

export const Button = styled("button", {
  border: 0,
  height: 48,
  color: "white",
  backgroundColor: "#7B61FF",
  borderRadius: "31px",
  cursor: "pointer",
  display: "inline",
  fontSize: "$2",
});

export function ColorPicker(props) {
  return (
    <Option>
      <CirclePicker
        circleSize={24}
        circleSpacing={8}
        colors={[
          "#ffffff",
          "#e91e63",
          "#3f51b5",
          "#2196f3",
          "#4caf50",
          "#795548",
          "#5C5C5C",
        ]}
        {...props}
      />
    </Option>
  );
}

const StyledSwitch = styled(SwitchPrimitive.Root, {
  all: "unset",
  width: 44,
  height: 24,
  marginRight: 17,
  background: "#9CA3AF",
  borderRadius: "9999px",
  position: "relative",
  boxShadow: `0 2px 10px ${blackA.blackA7}`,
  WebkitTapHighlightColor: "rgba(0, 0, 0, 0)",
  "&:focus": { boxShadow: `0 0 0 2px black` },
  '&[data-state="checked"]': {
    background: "#7B61FF",
  },
});

const StyledSwitchThumb = styled(SwitchPrimitive.Thumb, {
  display: "block",
  width: 20,
  height: 20,
  backgroundColor: "white",
  borderRadius: "9999px",
  boxShadow: `0 2px 2px ${blackA.blackA7}`,
  transition: "transform 100ms",
  transform: "translateX(2px)",
  willChange: "transform",
  '&[data-state="checked"]': { transform: "translateX(22px)" },
});

export function SwitchOption({ label, ...props }) {
  return (
    <Option>
      <Label>{label}</Label>
      <StyledSwitch {...props}>
        <StyledSwitchThumb />
      </StyledSwitch>
    </Option>
  );
}
